import React from "react";
import SectionHeader from "./SectionHeader";
import { BonusCard } from "../../../shared/components/cards";
import SkeletonBonusCard from "../../../shared/components/skeletons/SkeletonBonusCard";

/**
 * Promotions row. On mobile shows a single featured promo; on desktop a 3-up
 * grid. During the brief promosLoading window the huge_collection card renders
 * with resolved count copy (from promoList) while siblings show skeletons.
 *
 * Module-scope component (was inline in GameLobby's render body).
 */
const PromotionsSection = ({
  promoList,
  promoCards,
  promosLoading,
  isMobile,
  navigate,
}) => (
  <section className="mb-12">
    <SectionHeader title="Promotions" onViewAll={() => navigate("/promotions")} />

    {promosLoading ? (
      isMobile ? (
        <SkeletonBonusCard />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {promoList.slice(0, 3).map((p, idx) =>
            p.id === "huge_collection" ? (
              <BonusCard
                key={`lobby-promos-huge-${idx}`}
                variant={p.variant}
                subtitle={p.subtitle}
                title={p.title}
                highlight={p.highlight}
                description={p.description}
                buttonText={p.buttonText}
                onButtonClick={() => navigate(p.link)}
                image={p.image}
              />
            ) : (
              <SkeletonBonusCard key={`lobby-promos-skel-${idx}`} />
            ),
          )}
        </div>
      )
    ) : isMobile ? (
      <BonusCard
        variant={promoCards[0]?.variant}
        subtitle={promoCards[0]?.subtitle}
        title={promoCards[0]?.title}
        highlight={promoCards[0]?.highlight}
        description={promoCards[0]?.description}
        buttonText={promoCards[0]?.buttonText}
        onButtonClick={promoCards[0]?.onButtonClick}
        image={promoCards[0]?.image}
      />
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {promoCards.slice(0, 3).map((c, idx) => (
          <BonusCard
            key={c.key || idx}
            variant={c.variant}
            subtitle={c.subtitle}
            title={c.title}
            highlight={c.highlight}
            description={c.description}
            buttonText={c.buttonText}
            onButtonClick={c.onButtonClick}
            image={c.image}
          />
        ))}
      </div>
    )}
  </section>
);

export default PromotionsSection;
